import {REHYDRATE} from 'redux-persist';

const initialState = {
  growerId: null,
  emailAddress: null,
  authorizingUser: false,
  authorization: {},
  tokenExpired: false,
  growerIdOverride: null,
  emailAddressOverride: null,
  isBuyGrainWidgetUser: false,
  isPurchaseContractModalUser: false,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        if (action.payload.auth.authorization?.isYieldEstimatorUser === true) {
          return {
            ...state,
            ...action.payload.auth,
            authorizingUser: false,
          };
        }
        return {
          ...state,
          ...action.payload.auth,
          authorizingUser: false,
          authorization: {},
          tokenExpired: false,
        };
      }
      return state;

    case 'USER_AUTHORIZATION_STARTED':
      return {
        ...state,
        authorizingUser: true,
      };

    case 'USER_AUTHORIZATION_SUCCEEDED':
      return {
        ...state,
        authorizingUser: false,
        authorization: action.authorization,
        growerId: action.growerId,
        emailAddress: action.emailAddress,
        tokenExpired: false,
        growerIdOverride: action.growerIdOverride,
        emailAddressOverride: action.emailAddressOverride,
      };

    case 'USER_AUTHORIZATION_FAILED':
      return {
        ...state,
        authorizingUser: false,
      };

    case 'USER_AUTH_TOKEN_EXPIRED':
      return {
        ...state,
        tokenExpired: true,
        authorization: {},
      }

    case 'SET_IS_BUY_GRAIN_WIDGET_USER':
      return {
        ...state,
        isBuyGrainWidgetUser: action.isBuyGrainWidgetUser,
        isPurchaseContractModalUser: false,
      };
      
    case 'SET_IS_PURCHASE_CONTRACT_MODAL_USER':
      return {
        ...state,
        isPurchaseContractModalUser: action.isPurchaseContractModalUser,
        isBuyGrainWidgetUser: false,
      };

    default:
      return state;
  }
}
